var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMaritalStatusIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 3c0 .5.5 1 1 1 .6 0 1-.5 1-1 0-.6-.4-1-1-1-.5 0-1 .4-1 1zM8.4 8.7c-.3 1-1 3-1.6 4.5C4 20.7 13.3 25 17 18c.8-1.5.7-3.1-.4-6.3-1.2-3.6-1.8-4.2-4.5-4.5-2.3-.2-3.3.1-3.7 1.5zm5.3 2c-1.6 1.6-1.8 1.6-3.4 0C8.7 9.1 8.8 9 12 9s3.3.1 1.7 1.7zM16 14c1.5 2.8-.7 6-4 6-3.6 0-6.2-3.9-4.1-6.4 1.5-1.8 7-1.5 8.1.4z"
  })));
}

export default SvgMaritalStatusIcon;


//////////////////
// WEBPACK FOOTER
// ./src/icons/MaritalStatusIcon.svg
// module id = 875
// module chunks = 101